// Header scroll shadow
const header = document.getElementById('header');
if (header) {
    window.addEventListener('scroll', () => {
        header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
}

// Mobile menu
const hamburger = document.getElementById('hamburgerBtn');
const mobileMenu = document.getElementById('mobileMenu');
const mobileClose = document.getElementById('mobileClose');

if (hamburger && mobileMenu && mobileClose) {
    hamburger.addEventListener('click', () => {
        mobileMenu.classList.add('active');
        hamburger.classList.add('active');
        document.body.style.overflow = 'hidden';
    });
    mobileClose.addEventListener('click', () => {
        mobileMenu.classList.remove('active');
        hamburger.classList.remove('active');
        document.body.style.overflow = '';
    });
}

// Fade-in on scroll
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (!prefersReducedMotion) {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry, i) => {
            if (entry.isIntersecting) {
                setTimeout(() => {
                    entry.target.classList.add('visible');
                }, i * 80);
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.fade-in').forEach(el => observer.observe(el));
} else {
    document.querySelectorAll('.fade-in').forEach(el => el.classList.add('visible'));
}


// ===== Language switcher (SR <-> EN) =====
var __elsv = document.createElement('style');
__elsv.textContent = `
  .header-icons .lang-switcher { display: inline-flex !important; }
  @media (max-width: 480px) {
    .header-icons { gap: 4px !important; }
    .header-icons .lang-switcher { transform: scale(0.78); transform-origin: right center; margin-right: -4px; }
  }
  @media (min-width: 481px) and (max-width: 768px) {
    .header-icons .lang-switcher { transform: scale(0.9); transform-origin: right center; }
  }
`;
document.head.appendChild(__elsv);

document.addEventListener('click', function(e) {
  var btn = e.target.closest('.lang-switcher');
  if (!btn) return;
  e.preventDefault();
  var target = btn.classList.contains('is-en') ? 'sr' : 'en';
  var form = document.createElement('form');
  form.method = 'post';
  form.action = '/localization';
  form.style.display = 'none';
  [['_method','put'],['form_type','localization'],['utf8','✓'],['return_to', window.location.pathname + window.location.search],['locale_code', target]].forEach(function(p) {
    var i = document.createElement('input');
    i.type = 'hidden'; i.name = p[0]; i.value = p[1];
    form.appendChild(i);
  });
  document.body.appendChild(form);
  form.submit();
});